<template>
  <div v-if="showOutageBanner" class="outage-banner">
    <a-alert type="warning" show-icon banner :closable="false">
      <template #message>
        <span v-html="outageBannerMessage" />
      </template>
    </a-alert>
  </div>
  <template v-if="cognitoInitFailed">
    <AuthError :retryProfileLoad="false" />
  </template>
  <router-view v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/shared/stores/authStore';
import AuthError from '@/shared/components/Auth/AuthError.vue';

const authStore = useAuthStore();
const cognitoInitFailed = computed(() => authStore.lifecycleStatus.cognitoInitFailed);

const showOutageBanner = import.meta.env.VITE_SHOW_OUTAGE_BANNER === 'true';
const outageBannerMessage =
  import.meta.env.VITE_OUTAGE_BANNER_MESSAGE ||
  'We are currently experiencing degraded performance in some of our systems. We are working on restoring full service.';
</script>

<style lang="less">
@import 'assets/style/global';
</style>

<style lang="less" scoped>
.outage-banner {
  flex-shrink: 0;
}
.outage-banner :deep(.ant-alert) {
  margin: 0;
  border-radius: 0;
  display: flex;
  justify-content: center;
}
.outage-banner :deep(.ant-alert-content) {
  flex: 0 1 auto;
  text-align: center;
}
.outage-banner :deep(.ant-alert-icon) {
  margin-right: 8px;
}
</style>
